import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { useUserState } from 'contexts/auth-context';
import t from 'utils/translateFunc';
import trackingEvent from 'utils/trackingEvent';

import {
  InfoButton,
  Icon,
  TooltipForElement
} from 'components/common/Elements/Elements';

import classes from './СoincidencesPopap.module.scss';

const СoincidencesPopap = ({
  dataCoincidences,
  onClose,
  mixpanel,
  className,
  classNameBtnClose,
  onOfNotif
}) => {
  const language = useUserState().user.language;
  const username = useUserState().user.username;
  const isTrial = useUserState().user.trial;

  const [checkText, setCheckText] = useState(true);

  const parsCoincidencesText = (str, dataRatio = []) => {
    const openTag = '<span style="background-color: rgb(256, 214, 215)"> ';
    const closeTag = '</span> ';

    const insert = (str, index, openTag, closeTag, size) => {
      return (
        str.substr(0, index) +
        openTag +
        str.substr(index, size) +
        closeTag +
        str.substr(index + size)
      );
    };

    let newStr = str;
    let reduseInsertIndex = 0;
    dataRatio.forEach(ratio => {
      newStr = insert(
        newStr,
        ratio.b + reduseInsertIndex,
        openTag,
        closeTag,
        ratio.size,
        reduseInsertIndex
      );
      reduseInsertIndex = reduseInsertIndex + openTag.length + closeTag.length;
    });

    return newStr;
  };

  const onCopyLink = () => {
    trackingEvent('copy_link_article', mixpanel, username);
    const link = dataCoincidences.url;
    navigator.clipboard
      .writeText(link)
      .then(() => {
        onOfNotif('on', t('notif', 'COPY_LINK', language), false, '2000');
      })
      .catch(err => console.log(err));
  };

  return (
    <div>
      <div
        className={cn(
          classes.wrapTrapezoid,
          isTrial && classes.wrapTrapezoid_trial
        )}
      >
        <div className={classes.trapezoid}></div>
        <button
          className={cn(
            classes.closeButton,
            isTrial && classes.closeButton_trial,
            classNameBtnClose
          )}
          onClick={onClose}
        >
          <Icon icon={'Icn_Clear-2'} className={classes.iconClear} />
        </button>
      </div>
      <div
        className={cn(
          classes.coincidencesPopap,
          isTrial && classes.coincidencesPopap_trial,
          className
        )}
      >
        <div className={classes.headerPopap}>
          <p className={classes.wrapLink}>
            <a
              className={cn(classes.link, classes.hiddenText)}
              href={dataCoincidences.source.mainPageUrl}
              // eslint-disable-next-line
              target="_blank"
            >
              {dataCoincidences.source.mainPageUrl}
            </a>
            <button
              type="button"
              className={classes.copyLinkButton}
              onClick={onCopyLink}
            >
              <Icon icon={'Icn_Copy-Link'} className={classes.iconCopyLink} />
            </button>
          </p>
          <p className={classes.wrapPersent}>
            <TooltipForElement
              text={t('tooltip', 'TEXT', language)}
              className={classes.info}
            >
              <InfoButton />
            </TooltipForElement>
            {t('coincidencesPopap', 'MATCH_TEXT', language)}
            <span className={classes.persent}>{dataCoincidences.ratio}</span>
            <button
              className={classes.checkTextButton}
              onClick={() => {
                trackingEvent('check_text', mixpanel, username);
                setCheckText(!checkText);
              }}
            >
              <Icon
                icon={checkText ? 'Icn_heck-text' : 'Icn_heck-text-1'}
                className={classes.iconCheckText}
              />
            </button>
          </p>
        </div>
        <div className={classes.contentPopap}>
          <div className={classes.widgetPanel}>
            {/* <p>
              {t('coincidencesPopap', 'NUMBER', language)}
              {dataCoincidences.averageAttendance}
            </p> */}
            <div className={classes.widgetGroups}>
              {dataCoincidences.author && (
                <p className={cn(classes.widget, classes.widget_notLastChild)}>
                  {dataCoincidences.author}
                </p>
              )}

              <TooltipForElement text={t('tooltip', 'AUDIENCE', language)}>
                <p className={cn(classes.widget, classes.widget_notLastChild)}>
                  <Icon
                    icon={'Icn_Audience-1'}
                    className={classes.iconAudience}
                  />
                  {dataCoincidences.source.attendance}
                </p>
              </TooltipForElement>
              <TooltipForElement text={t('tooltip', 'VIEWING', language)}>
                <p className={classes.widget}>
                  <Icon
                    icon={'icn_Number-of-views'}
                    className={classes.iconNumberViews}
                  />
                  {dataCoincidences.averageAttendance}
                </p>
              </TooltipForElement>
            </div>
          </div>
          <h2 className={classes.title}>{dataCoincidences.title}</h2>
          <p className={classes.date}>{dataCoincidences.date}</p>
          <div
            className={classes.textRelease}
            dangerouslySetInnerHTML={{
              __html: checkText
                ? parsCoincidencesText(
                    dataCoincidences.text,
                    dataCoincidences.matchingBlocks
                  )
                : dataCoincidences.text
            }}
          />
        </div>
      </div>
    </div>
  );
};

СoincidencesPopap.propTypes = {
  dataCoincidences: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onOfNotif: PropTypes.func,
  // mixpanel: PropTypes.object,
  className: PropTypes.string,
  classNameBtnClose: PropTypes.string
};

export default СoincidencesPopap;
